<!-- Page body start -->
<div class="page-body">
  <div class="row">
    <div class="col-sm-12">
      <!-- Post community card start -->
      <div class="card">
        <div class="card-header">
          <h5>Post your uMuzi here</h5>
          <span
            >Create your own uMuzi and connect with others with similar
            interests
          </span>
          <div class="card-header-right">
            <i class="icofont icofont-spinner-alt-5"></i>
          </div>
        </div>

        <list-errors [errors]="errors"></list-errors>

        <div class="card-block">
          <!-- Loader spinner -->
          <loader-animation
            [loading]="isSubmitting"
            [message]="'Publishing your uMuzi'"
          >
          </loader-animation>
          <!-- Loader spinner -->

          <div class="j-wrapper j-wrapper-640" [hidden]="isSubmitting">
            <form
              [formGroup]="communityForm"
              class="j-pro form-control md-float-material"
              id="j-pro"
              (keydown.enter)="$event.preventDefault()"
            >
              <div class="j-content">
                <div class="j-row">
                  <!-- start name -->
                  <div class="j-span12 j-unit">
                    <div>
                      <h5 class="sub-title">
                        <span>Name</span>

                        <span
                          class="text-danger"
                          *ngIf="communityForm.controls.name.errors?.required"
                        >
                          * &nbsp;
                        </span>
                      </h5>
                    </div>
                    <div class="j-input">
                      <label class="j-icon-left" for="name">
                        <i class="icofont icofont-quill-pen"></i>
                      </label>
                      <input
                        formControlName="name"
                        type="text"
                        id="name"
                        name="name"
                        placeholder="uMuzi name e.g NWA or Transformers-Armada or Autobots_Community"
                        class="name-group"
                        (keydown.enter)="$event.preventDefault()"
                      />
                    </div>

                    <div
                      class="messages text-danger validation-error-message"
                      *ngIf="
                        communityForm.controls.name.errors?.required &&
                        communityForm.controls.name.touched
                      "
                    >
                      Name can't be blank
                    </div>
                  </div>
                  <!-- end name -->

                  <!-- start summary -->
                  <div class="j-span12 j-unit">
                    <div>
                      <h5 class="sub-title">
                        <span>Summary</span>

                        <span
                          class="text-danger"
                          *ngIf="
                            communityForm.controls.summary.errors?.required
                          "
                        >
                          * &nbsp;
                        </span>
                      </h5>
                    </div>
                    <div class="j-input">
                      <label class="j-icon-left" for="summary">
                        <i class="icofont icofont-question-square"></i>
                      </label>
                      <input
                        formControlName="summary"
                        type="text"
                        id="summary"
                        name="summary"
                        placeholder="What's this uMuzi about?"
                        class="name-group"
                        (keydown.enter)="$event.preventDefault()"
                      />
                    </div>

                    <div
                      class="messages text-danger validation-error-message"
                      *ngIf="
                        communityForm.controls.summary.errors?.required &&
                        communityForm.controls.summary.touched
                      "
                    >
                      Summary can't be blank
                    </div>
                  </div>
                  <!-- end summary -->

                  <!-- start image field -->
                  <div
                    *ngIf="community && community.id"
                    class="j-span12 j-unit"
                  >
                    <div>
                      <h5 class="sub-title">Upload image</h5>
                    </div>
                    <div class="j-input">
                      <label class="j-icon-left" for="image">
                        <i class="icofont icofont-camera"></i>
                      </label>
                      <input
                        formControlName="image"
                        type="text"
                        id="image"
                        name="image"
                        placeholder="URL of profile picture"
                        class="name-group"
                        (keydown.enter)="$event.preventDefault()"
                      />
                    </div>
                  </div>
                  <!-- end image field -->

                  <!-- start add photo -->
                  <div class="j-span12 j-unit text-center">
                    <upload-image-button
                      [targetObject]="community"
                      [targetType]="'Community'"
                      (emitImage)="saveImage($event)"
                    >
                    </upload-image-button>
                  </div>
                  <!-- end add photo -->

                  <!-- start tagList -->
                  <div class="j-span12 j-unit">
                    <div>
                      <h5 class="sub-title">
                        <span>
                          Add tags: Please add 1 or more by entering text and
                        </span>
                        <span class="text-info">pressing enter</span>
                      </h5>
                    </div>

                    <div class="j-input">
                      <label class="j-icon-right" for="tagList">
                        <i class="icofont icofont-tags"></i>
                      </label>

                      <tag-input
                        [ngModel]="community.tagList"
                        [ngClass]="'tag-select'"
                        theme="bootstrap"
                        [maxItems]="10"
                        formControlName="tagList"
                        [modelAsStrings]="true"
                        [editable]="true"
                        [placeholder]="'+ Add'"
                        [secondaryPlaceholder]="'Enter tags'"
                        (keydown.enter)="$event.preventDefault()"
                      >
                        <tag-input-dropdown [showDropdownIfEmpty]="true">
                        </tag-input-dropdown>
                      </tag-input>
                    </div>
                  </div>
                  <!-- end tagList -->
                </div>

                <!-- start description -->
                <div class="j-unit">
                  <div>
                    <h5 class="sub-title">
                      <span>Description</span>

                      <span
                        class="text-danger"
                        *ngIf="
                          communityForm.controls.description.errors?.required
                        "
                      >
                        * &nbsp;
                      </span>
                    </h5>
                  </div>
                  <div class="j-input">
                    <angular-editor
                      formControlName="description"
                      [config]="editorConfig"
                    >
                    </angular-editor>
                  </div>

                  <div
                    class="messages text-danger validation-error-message"
                    *ngIf="
                      communityForm.controls.description.errors?.required &&
                      communityForm.controls.description.touched
                    "
                  >
                    Description can't be blank
                  </div>
                </div>
                <!-- end description -->

                <!-- delete community button -->
                <div *ngIf="community && community.id" class="j-unit">
                  <div>
                    <h5 class="sub-title">Delete</h5>
                  </div>
                  <div class="j-input">
                    <del-community-button [community]="community">
                    </del-community-button>
                  </div>
                </div>
                <!-- delete community button -->
              </div>

              <!-- end /.content -->
              <div class="j-footer">
                <button
                  [disabled]="!communityForm.valid"
                  type="submit"
                  class="btn btn-primary"
                  (click)="openCommunityPublishConfirmation()"
                >
                  <i class="icofont icofont-paper-plane"></i>
                  Publish uMuzi
                </button>
              </div>
              <!-- end /.footer -->
            </form>
          </div>
        </div>
      </div>
      <!-- Post community card end -->
    </div>
  </div>
</div>
<!-- Page body end -->
